"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
(function (angularModule) {
    angularModule.factory('prRankedDisplayLogic', [
        'prFieldMenu',
        'pr.dataRequestService',
        'pr.filters',
        'prFilterUtils',
        function (
        // @ts-ignore
        fieldMenu, 
        // @ts-ignore
        dataRequestService, 
        // @ts-ignore
        prFilters, 
        // @ts-ignore
        filterUtils) {
            var FIELD_IDS_TO_IGNORE = [
                'status',
                'progress',
                'duration',
                'finished'
            ];
            var questionIds = [];
            var scoringCategoriesIds = [];
            /**
             * Computes the averages of all fields and/or scoring categories in the project
             */
            function computeRankedDisplayLogic(dataConfig, sourceId, calculateFields, calculateScoringCategories) {
                if (calculateFields && calculateScoringCategories) {
                    return calculateAveragesForFields(dataConfig, sourceId).then(function (averages) {
                        var fieldAverages = constructJSONFields(averages.data, questionIds);
                        return calculateAveragesForScoringCategories(dataConfig, sourceId).then(function (categoryAverages) {
                            var scoringCategoryAverages = constructJSONScoringCategories(categoryAverages.data, scoringCategoriesIds);
                            return [fieldAverages, scoringCategoryAverages];
                        });
                    });
                }
                else if (calculateFields) {
                    return calculateAveragesForFields(dataConfig, sourceId).then(function (averages) {
                        return [constructJSONFields(averages.data, questionIds)];
                    });
                }
                else if (calculateScoringCategories) {
                    return calculateAveragesForScoringCategories(dataConfig, sourceId).then(function (averages) {
                        return [constructJSONScoringCategories(averages.data, scoringCategoriesIds)];
                    });
                }
            }
            /**
             * Returns a json object of each field and the corresponding averages
             * For example:
             * {QID1_11: 23.5, QID1_12: 24}
             *
             * @param averageFieldsData - the averages for each of the fields
             * @param ids - array of question field ids
             */
            // @ts-ignore
            function constructJSONFields(averageFieldsData, ids) {
                var fieldsJsonObject = {};
                var index = 0;
                lodash_1.default.forEach(averageFieldsData.data, function (field) {
                    // @ts-ignore
                    fieldsJsonObject[ids[index]] = field.value;
                    index += 1;
                });
                return fieldsJsonObject;
            }
            /**
             * Returns a json object of each scoring category and the corresponding averages
             * For example:
             * {SC1: 23.5, SC2: 24}
             *
             * @param averageSCData - the averages for each scoring category
             * @param ids
             */
            // @ts-ignore
            function constructJSONScoringCategories(averageSCData, ids) {
                var scJsonObject = {};
                var index = 0;
                // The format in which data platform sends scoring category data
                // is different depending on whether there is one category vs multiple.
                // We have to handle the two cases differently.
                if (averageSCData.data.length === 1) {
                    var scItem = averageSCData.data[0];
                    // @ts-ignore
                    scJsonObject[ids[index]] = scItem.value;
                }
                else {
                    lodash_1.default.forEach(averageSCData.data, function (scItem) {
                        // @ts-ignore
                        scJsonObject[ids[index]] = scItem[0].value.value;
                        index += 1;
                    });
                }
                return scJsonObject;
            }
            function calculateAveragesForFields(dataConfig, sourceId) {
                return getAllFieldIds(sourceId).then(function (fieldIds) {
                    var dataRequest = prepDataRequestForAvgRequest(fieldIds, dataConfig, sourceId);
                    return dataRequestService.post(dataRequest, 'aggregate', {
                        useCache: true,
                        sourceId: sourceId
                        // @ts-ignore
                    }).then(function (values) {
                        return values;
                    });
                });
            }
            function calculateAveragesForScoringCategories(dataConfig, sourceId) {
                return getAllScoringCategories(sourceId).then(function (categories) {
                    var dataRequest = prepDataRequestForAvgRequest(categories, dataConfig, sourceId);
                    return dataRequestService.post(dataRequest, 'aggregate', {
                        useCache: true,
                        sourceId: sourceId
                        // @ts-ignore
                    }).then(function (values) {
                        return values;
                    });
                });
            }
            /**
             * Returns a list of all the numeric fields IDs used in the source ID
             */
            function getAllFieldIds(sourceId) {
                var menuOptions = {
                    includeAllChoices: false,
                    removeSurveyMetadata: true,
                    rawFields: true,
                    fieldAsValue: false,
                    filter: ['EnumerableScalarValue', 'ScalarValue'] // Only numeric fields are supported for now
                };
                var listOfQuestions = [];
                // @ts-ignore
                return new fieldMenu(sourceId).get(menuOptions).then(function (fields) {
                    lodash_1.default.forEach(fields, function (field) {
                        if (!FIELD_IDS_TO_IGNORE.includes(field.value)) {
                            listOfQuestions.push(field.value);
                        }
                    });
                    questionIds = listOfQuestions;
                    return listOfQuestions;
                });
            }
            /**
             * Returns a list of all the scoring categories IDs used in the source ID
             */
            function getAllScoringCategories(sourceId) {
                var menuOptions = {
                    includeAllChoices: false,
                    onlyCategories: true,
                    removeSurveyMetadata: true,
                    fieldAsValue: false
                };
                var categories = [];
                // @ts-ignore
                return new fieldMenu(sourceId).get(menuOptions).then(function (values) {
                    var _a, _b, _c;
                    var scoringCategories = (_c = (_b = (_a = values[0]) === null || _a === void 0 ? void 0 : _a.submenu) === null || _b === void 0 ? void 0 : _b.items) !== null && _c !== void 0 ? _c : [];
                    lodash_1.default.forEach(scoringCategories, function (category) {
                        categories.push(category.value);
                    });
                    scoringCategoriesIds = categories;
                    return categories;
                });
            }
            function prepDataRequestForAvgRequest(fieldIds, dataConfig, sourceId) {
                var metrics = [];
                var filters = prepRequestFilters(dataConfig.filters, sourceId);
                lodash_1.default.forEach(fieldIds, function (currId) {
                    var isValidId = isValidRankableFieldType(currId);
                    if (!isValidId) {
                        throw Error('Unsupported type of field');
                    }
                    var currMetric = {
                        fieldId: currId,
                        type: 'avg'
                    };
                    metrics.push(currMetric);
                });
                var dataRequest = {
                    dataType: 'aggregate',
                    sourceId: sourceId,
                    metrics: metrics,
                    filters: filters
                };
                return dataRequest;
            }
            function isValidRankableFieldType(id) {
                if (lodash_1.default.startsWith(id, 'Q') || lodash_1.default.startsWith(id, 'SC')) {
                    return true;
                }
                return false;
            }
            function prepRequestFilters(widgetFilters, sourceId) {
                var overrideFilters = prFilters.getOverrideFilters();
                overrideFilters = (overrideFilters || {})[sourceId] || {};
                var overrideFiltersCopy = lodash_1.default.cloneDeep(overrideFilters);
                widgetFilters = (widgetFilters || {})[sourceId] || {};
                var widgetFiltersCopy = lodash_1.default.cloneDeep(widgetFilters);
                filterUtils.fixDateFilters(overrideFiltersCopy);
                filterUtils.fixDateFilters(widgetFiltersCopy);
                return {
                    type: 'and',
                    children: [widgetFiltersCopy, overrideFiltersCopy]
                };
            }
            return {
                computeRankedDisplayLogic: computeRankedDisplayLogic,
                getAllFieldIds: getAllFieldIds,
                prepDataRequestForAvgRequest: prepDataRequestForAvgRequest,
                getAllScoringCategories: getAllScoringCategories,
                calculateAveragesForFields: calculateAveragesForFields,
                calculateAveragesForScoringCategories: calculateAveragesForScoringCategories,
                constructJSONScoringCategories: constructJSONScoringCategories,
                constructJSONFields: constructJSONFields
            };
        }
    ]);
})(angular_1.module('qualtrics.pr'));
